import React from 'react';
import { applyComponentTheme } from '../../../../theme';
import { Grid, GridItem } from '../../../Grid';
import { TextInputProps } from '../../TextInput';
import { InputComponent } from '../../inputTypes';
import { YearInput as YearStyledTextInput } from '../styles';

const YearInput: InputComponent<Omit<
  TextInputProps,
  'numbersOnly' | 'maxLength' | 'placeholder'
>> = (props) => (
  <Grid alignLeft>
    <GridItem desktop={4} tabletLandscape={4} tabletPortrait={4}>
      <YearStyledTextInput {...props} numbersOnly maxLength={4} placeholder="YYYY" />
    </GridItem>
  </Grid>
);

export default applyComponentTheme(YearInput, 'YearInput');
